import { Box, Button, FormControl, TextField, Typography } from "@mui/material";
import React from "react";
import { useForm } from "react-hook-form";

import { blackColor, primaryColor } from "theme";

import { useAgentSignUpMutation } from "../../redux/modules/onboarding";

const SignupModal = ({
  setCurrentPage,
  setSnackbarData,
  setOpenSnackbar,setEmail
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();
  const [signUp, {isLoading}] = useAgentSignUpMutation();


  const onSubmit = (data) => {
    const payload = {
      firstName: data.firstName,
      lastName: data.lastName,
      businessName: data.businessName,
      businessType: "AGENCY",
      email: data.email,
      password: data.password
    };
    signUp(payload)
      .unwrap()
      .then((res) => {
        setEmail(data.email);
        setOpenSnackbar(true);
        setSnackbarData({
          message: res.message,
          severity: "success"
        });
        // handleClose();
        setCurrentPage("otp");
      })
      .catch((err) => {
        setOpenSnackbar(true);
        setSnackbarData({
          message: err.data.message,
          severity: "error"
        });
      });
  };

  return (
    <>
      <Typography
        fontSize="24px"
        textAlign="center"
        fontWeight={700}
        id="parent-modal-title"
        className="modal-title"
      >
        Sign Up to continue
      </Typography>

      <Box
        sx={{
          width: "100%",
          display: "flex",
          mb: "1rem"
        }}
      >
        <FormControl
          sx={{
            mr: 2,
            bgcolor: "white",
            position: "relative"
          }}
          fullWidth
          variant="outlined"
        >
          <TextField
            size="small"
            label="First Name"
            error={!!errors.firstName}
            {...register("firstName", { required: true })}
            sx={{
              width: "100%",
              bgcolor: "white",
              fieldset: { borderColor: "#C4CAD3" }
            }}
            placeholder="Ex: Jack"
            InputProps={{
              sx: {
                borderColor: "#C4CAD3",
                borderRadius: "4px",
                width: "100%",
                bgcolor: "white",
                maxHeight: "40px"
              }
            }}
            variant="outlined"
          />
        </FormControl>
        <FormControl
          sx={{
            bgcolor: "white",
            position: "relative"
          }}
          fullWidth
          variant="outlined"
        >
          <TextField
            size="small"
            label="Last Name"
            error={!!errors.lastName}
            {...register("lastName", { required: true })}
            sx={{
              width: "100%",
              bgcolor: "white",
              fieldset: { borderColor: "#C4CAD3" }
            }}
            placeholder="Ex: Callies"
            InputProps={{
              sx: {
                borderColor: "#C4CAD3",
                borderRadius: "4px",
                width: "100%",
                bgcolor: "white",
                maxHeight: "40px"
              }
            }}
            variant="outlined"
          />
        </FormControl>
      </Box>
      <FormControl
        sx={{
          bgcolor: "white",
          position: "relative",
          mb: "1rem"
        }}
        fullWidth
        variant="outlined"
      >
        <TextField
          size="small"
          label="Business Name"
          error={!!errors.businessName}
          {...register("businessName", { required: true })}
          sx={{
            width: "100%",
            bgcolor: "white",
            fieldset: { borderColor: "#C4CAD3" }
          }}
          placeholder="Ex: Accuty Insurance"
          InputProps={{
            sx: {
              borderColor: "#C4CAD3",
              borderRadius: "4px",
              width: "100%",
              bgcolor: "white",
              maxHeight: "40px"
            }
          }}
          variant="outlined"
        />
      </FormControl>
      <FormControl
        sx={{
          bgcolor: "white",
          position: "relative",
          mb: "1rem"
        }}
        fullWidth
        variant="outlined"
      >
        <TextField
          size="small"
          label="Email"
          error={!!errors.email}
          {...register("email", { required: true })}
          sx={{
            width: "100%",
            bgcolor: "white",
            fieldset: { borderColor: "#C4CAD3" }
          }}
          placeholder="Ex: jack.callies@gmail.com"
          InputProps={{
            sx: {
              borderColor: "#C4CAD3",
              borderRadius: "4px",
              width: "100%",
              bgcolor: "white",
              maxHeight: "40px"
            }
          }}
          variant="outlined"
        />
      </FormControl>
      <FormControl
        sx={{
          bgcolor: "white",
          position: "relative"
        }}
        fullWidth
        variant="outlined"
      >
        <TextField
          size="small"
          label="Password"
          error={!!errors.password}
          {...register("password", { required: true })}
          type="password"
          sx={{
            width: "100%",
            bgcolor: "white",
            fieldset: { borderColor: "#C4CAD3" }
          }}
          placeholder="Ex: jack.callies@gmail.com"
          InputProps={{
            sx: {
              borderColor: "#C4CAD3",
              borderRadius: "4px",
              width: "100%",
              bgcolor: "white",
              maxHeight: "40px"
            }
          }}
          variant="outlined"
        />
      </FormControl>

      <Button
        sx={{
          mt: "1.5rem",
          width: "100%",
          height: "43px"
        }}
        variant="primary"
        disabled={isLoading}
        onClick={handleSubmit(onSubmit)}
      >
        Create Account
      </Button>
      <Typography
        sx={{ mt: "1rem" }}
        textAlign="center"
        fontSize="13px"
        color={blackColor}
      >
        Already have an account?{" "}
        <span
          onClick={() => setCurrentPage("login")}
          style={{
            color: primaryColor,
            fontSize: ".875rem",
            cursor: "pointer"
          }}
        >
          Sign In
        </span>
      </Typography>
    </>
  );
};

export default SignupModal;
